import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import DatePicker from 'react-datepicker2';
import Document from "./Document";
import GridConfig from "./GridConfig";

export default class BankTransactionReport extends Base {
	constructor(props) {
		super(props);
		this.state = {
			data: null,
            loading: true,
            fromDate: null,
            toDate: null,
            accountId: null,
            configName: 'banktransaction_report',
		}
	}
    componentDidMount() {
        this.getData();
    }
    getData() {
        this.httpPost("api/v1/report/banktransaction")
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.setState({
                    data: data,
                    loading: false
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    showDocument(id) {
        this.showComponents({ component: <Document Caller={this} Id={id} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "date", caption: "تاریخ", show: true },
                { field: "documentNumber", caption: "سند", show: true },
                { field: "description", caption: "شرح", show: true },
                { field: "bed", caption: "بدهکار", show: true },
                { field: "bes", caption: "بستانکار", show: true },
                { field: "remain", caption: "مانده", show: true },
                { field: "tashkis", caption: "تشخیص", show: true },
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'date' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'documentNumber' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.showDocument(props.data.documentId)}>{props.data.documentNumber}</a> } });
            if (f.field == 'description' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'bed' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.bed) } });
            if (f.field == 'bes' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.bes) } });
            if (f.field == 'remain' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.remain) } });
            if (f.field == 'tashkis' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        return t;
    }
	renderForm() {
        return <div className="container">
            <div className="row">
                <div className="col-sm-12">
                    <div className="panel panel-info">
                        <div className="panel-body">
                            <div className="col-sm-3">
                                گردش حساب بانک
                            </div>
                            <div className="col-sm-6 text-center" style={{ "display": "flex", "place-content": "center" }}>
                                از
                                <DatePicker
                                    inputReadOnly={true}
                                    className="range-from-example text-center mr-l-5 mr-r-5"
                                    style={{ border: "solid 1px #ccc" }}
                                    placeholder={"تاریخ"}
                                    isGregorian={false}
                                    showTodayButton={true}
                                    timePicker={false}
                                    onChange={(e) => { this.state.fromDate = e }}
                                    value={this.getFormatedDateForDatePicker(this.state.fromDate)}
                                />
                                تا
                                <DatePicker
                                    inputReadOnly={true}
                                    className="range-to-example text-center mr-r-5"
                                    style={{ border: "solid 1px #ccc" }}
                                    placeholder={"تاریخ"}
                                    isGregorian={false}
                                    showTodayButton={true}
                                    timePicker={false}
                                    onChange={(e) => { this.state.toDate = e }}
                                    value={this.getFormatedDateForDatePicker(this.state.toDate)}
                                />
                                <a className="hand mr-r-5" onClick={e => this.getData()}><i className="fa fa-search"></i></a>
                            </div>
                            <div className="col-sm-3 text-left">
                                <button className="btn btn-no-frame btn-smoke hand" onClick={ e=>this.onPrint('تراکنشهای حسابهای بانکی') } title="چاپ">
                                    <span className="fa fa-print"></span>
                                </button>
                                <button className="btn btn-no-frame btn-smoke hand" onClick={e => this.onPdf('تراکنشهای حسابهای بانکی')} title="PDF">
                                    <span className="fa fa-file-pdf-o"></span>
                                </button>
                                <button className="btn btn-no-frame btn-smoke hand" onClick={e => this.onExcel('تراکنشهای حسابهای بانکی')} title="اکسل">
                                    <span className="fa fa-file-excel-o"></span>
                                </button>
                                <a className="btn btn-no-frame btn-smoke btn-sm pull-left" onClick={e => this.onGridConfig()} title="تنظیمات نمایش">
                                    <span className="fa fa-cog"></span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {this.renderAgGrid({
                columnDefs: this.getColumns()
            })}
        </div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				<Header data={this.state.data} />,
                this.renderForm(),
                this.renderPopupComponent(),
				<Footer />
			];

		return contents;
	}
}